/**
 * Tags 模块接口
 * 标签管理相关
 */

import { get, post } from '../request';
import type { CopyTagParams, GetTagListParams, TagItem, TagTemplate } from '../../type/tag-type';
import type { BasePageListData } from '../../type/common-type';

/**
 * 获取标签列表
 * GET /tags
 */
export const getTagList = (params?: GetTagListParams) => {
  return get<BasePageListData<TagItem>, GetTagListParams | undefined>('/tags', params);
};

/**
 * 获取标签模版详情，用于复制标签页面回填模版相关字段
 * GET /tags/templates/:templateKey
 */
export const getTagTemplate = (templateKey: string) => {
  return get<TagTemplate>(`/tags/templates/${encodeURIComponent(templateKey)}`);
};

/**
 * 基于参考标签 + 模版生成新标签
 * POST /tags/copy
 */
export const copyTag = (params: CopyTagParams) => {
  return post<TagItem>('/tags/copy', params);
};
